/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ServiceInstance} from "../models/service-instance";
import {ServiceService} from "../services/service.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class ServiceInstancesResolver implements Resolve<ServiceInstance[]> {

  constructor(
    private mServiceService: ServiceService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ServiceInstance[]> {
    try {
      return await this.mServiceService.getAllServiceInstances();
    } catch (error) {
      console.error("Problem resolving Service Instance... Error: " + error, error);
    }
  }

}
